import React from 'react'
import Meta from '../modules/meta'

const metadata = {
  title: 'Me connaitre | Psychologue clinicienne les arceaux | Morgane Laroche',
  description:
    'Ma formation de psychologue. Spécialisations, approches et méthodes. Quelques axes de travail. psychologue jardin des plantes',
}

const MeConnaitre = () => (
  <div className="container container--page">
    <Meta title={metadata.title} description={metadata.description} />
    <div className="container__block">
      <h1 className="container__block-title container__block-title--nomarge">
        ME CONNAITRE
      </h1>
      <h2 className="container__block-subtitle">Ma formation</h2>
      <p className="u-paragraphe">
        Diplômée d’un Master 2 en Psychopathologie et Psychologie clinique&nbsp;
        <a
          className="container__block-link"
          href="http://www.univ-lyon2.fr/"
          target="_blank"
        >
          (Université Lumière de Lyon II)
        </a>, je me suis d’abord familiarisée à l’approche intégrative au cours
        de mes trois années de Licence réalisées à la&nbsp;
        <a
          className="container__block-link"
          href="https://www.u-bourgogne.fr/"
          target="_blank"
        >
          faculté de Bourgogne
        </a>. Cette approche propose de s’appuyer sur différentes méthodes,
        courants de pensées et outils en mettant l’accent sur leur
        complémentarité. Elle considère qu’aucune technique, à elle seule, n’est
        suffisamment complète et adaptée et qu’il est préférable de les unifier
        afin de pouvoir répondre à chaque individu et aux problématiques qui
        l’animent.
      </p>
      <p className="u-paragraphe u-mb">
        Par la suite, j’ai souhaité m’intéresser davantage à&nbsp;
        <span className="u-bold">l'approche psychanalytique</span> qui m'a
        particulièrement fait écho, socle à partir duquel ma pratique s'inspire,
        en laissant libre court à la parole, aux choses que l’on ne dit pas au
        premier abord mais qui s’entendent au-delà des mots. En cela, elle
        suppose une écoute des enjeux et processus inconscients, du rêve, des
        émotions que l'on retient ou au contraire, qui nous débordent.
      </p>
      <h2 className="container__block-subtitle">Mon parcours</h2>
      <p className="u-paragraphe">
        Mon parcours a essentiellement débuté par des expériences
        professionnelles dans le champ de la psychiatrie (en hôpital
        psychiatrique, en Centre médico-psychologique et en foyer de vie
        accueillant des individus en situation de handicap psychique) auprès de
        patients adultes mais également d'enfants et adolescents. En ces
        différents lieux, je me suis particulièrement intéressée aux dimensions
        suivantes :
      </p>
      <ul className="container__content-list u-mb">
        <li>
          <span className="u-bold">La dimension psychosomatique :</span>&nbsp;elle
          envisage le corps comme une scène du psychisme. Quand la parole ne
          suffit plus ou semble faire impasse pour un individu, c’est parfois à
          travers le corps et ses maux, que nos difficultés, nos angoisses
          s’expriment. En s’y intéressant de plus près, les prémices d’une
          parole, d'une souffrance jusqu’ici indicibles vont pouvoir naître.
        </li>
        <li>
          <span className="u-bold">La dimension inter/transculturelle :</span>&nbsp;
          elle consiste à entendre la parole de l’autre en tant qu’individu issu
          d’une culture spécifique et de son appartenance à un environnement
          social et familial. Elle participe à la construction de l’identité
          (histoire familiale, héritage culturel, transmission généalogique),
          donc au développement du sujet. Elle peut apporter un éclairage face à
          des problématiques dont les nœuds sont parfois difficiles à démêler.
        </li>
        <li>
          <span className="u-bold">Les problématiques addictives :</span>&nbsp;elles
          sont autant de tentatives pour « faire face » à des épreuves
          douloureuses de séparations, de pertes, de deuils (pour ne citer que
          celles-ci) qui peuvent parfois sembler indépassables pour un individu.
          Cet espace, dans lequel je vous accueille, invite à libérer la parole
          afin d’accéder à un travail de mise en mots de ces vécus douloureux et
          des sentiments qui les accompagnent.
        </li>
      </ul>
      <p className="u-paragraphe">
        Par la suite, je me suis dirigée vers le domaine de la gériatrie. De
        l'hôpital gériatrique à l'EHPAD, cette pratique m'a invitée à considérer
        tant la dimension psychique individuelle des patients/résidents
        accueillis que celle de leurs proches aidants, mais également, des
        équipes dédiées à leur accompagnement. Cela m'a sensibilisée à l'écoute
        et l'accompagnement des familles et les retentissements dans
        l'accompagnement de leur proche. Cette expérience a notamment orienté ma
        pratique vers des dispositifs groupaux à travers l'animation de groupes
        de paroles ou d'instances de réflexion telles que les Commission Éthique
        et Bientraitance.
      </p>
      <p className="u-paragraphe">
        Ces différentes expériences en institution ont été autant de réflexion
        sur la spécificité de chaque population accueillie, allant du petit au
        grand âge, qu'une réflexion relative aux mouvements psychiques de
        groupes, leurs mécanismes et leurs enjeux.
      </p>
      <p className="u-paragraphe">
        Actuellement, j'accueille des patients adultes en consultations
        individuelles. Je ne pratique ni la thérapie familiale ni la thérapie de
        couple.
      </p>
      <p className="u-paragraphe">
        Un travail régulier de supervision individuelle, de formation (lectures,
        conférences, etc) vient encadrer et enrichir ma pratique.
      </p>
    </div>
  </div>
)
export default MeConnaitre



// WEBPACK FOOTER //
// ./src/pages/me-connaitre.js